import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { GdprPanel } from "@/components/LegalPanels";

export default function CompanySettings() {
  const { user, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [neu, setNeu] = useState("");
  const changePwd = async () => {
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: neu });
      toast.success("Password aggiornata");
      setCur(""); setNeu("");
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <div className="max-w-2xl">
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Impostazioni</h1>
      <p className="text-sm text-slate-600 mb-6">Gestisci account, sicurezza e diritti GDPR.</p>
      <div className="cxo-card p-6 space-y-4">
        <h3 className="font-semibold text-slate-900">Account</h3>
        <div><Label>Email</Label><Input value={user?.email || ""} disabled /></div>
        <div><Label>Ruolo</Label><Input value={user?.role || ""} disabled /></div>
        <Button variant="outline" onClick={() => { logout(); window.location.href = "/"; }} className="mt-2" data-testid="settings-logout">Esci dall'account</Button>
      </div>
      <div className="cxo-card p-6 mt-4 space-y-4">
        <h3 className="font-semibold text-slate-900">Cambia password</h3>
        <div><Label>Password attuale</Label><Input type="password" value={cur} onChange={e => setCur(e.target.value)} /></div>
        <div><Label>Nuova password</Label><Input type="password" value={neu} onChange={e => setNeu(e.target.value)} /></div>
        <Button onClick={changePwd} disabled={!cur || !neu} className="bg-[#2D6BFF] text-white">Aggiorna password</Button>
      </div>
      <GdprPanel />
    </div>
  );
}
